import { CRBTUICSSStyle, CRBTUICSSStyleImpl } from '../crbt/crbtuicss';

export interface LandingPageListCSSStyle extends CRBTUICSSStyle
{
   
}

export class LandingPageListCSSStyleImpl extends CRBTUICSSStyleImpl implements LandingPageListCSSStyle
{
   getWrapperCSSStyle(): object
   {
        return {
            height: "100%",
            width: "100%"
        };
   }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/landingpagelist/landingpagelistcss.tsx